import styled from 'styled-components';
import color from '../utils/style/color';
import space from '../utils/style/space';

const ConfirmEmailSentModalBackground = styled.div`
  width: 500px;
  background-color: ${color.gray.xxxxBright};
  padding: ${space.xxxl}px;
  box-sizing: border-box;
  text-align: center;

  @media screen and (max-width: 576px) {
    width: 357px;
    padding: ${space.xl}px;
  }
`;

export default ConfirmEmailSentModalBackground;
